import feedback from './feedback';
import report from './report';
import global from './global';

const models = [
  feedback,
  report,
  global
];

export default models;
